/* Moteur de page d'entité / grosse collection — index catalogue worker.
   Facettes : Auteur, Collection (croisées searchables, cases à cocher), Date (décennie),
   Format, Langue, État (icônes), Éditeur (croisé, en fin). Cartes produit enrichies. */
(function () {
  const cfg = document.getElementById('cat-entity-config');
  if (!cfg) return;
  const ETYPE  = cfg.dataset.etype;
  const HANDLE = cfg.dataset.handle;
  const WORKER = (cfg.dataset.worker || '').replace(/\/$/, '');
  const PER    = parseInt(cfg.dataset.per || '48', 10);
  const PRODUCT_TYPE = (cfg.dataset.productType || '').toLowerCase();
  // Langue masquée pour CD / DVD / Vinyle / K7 (peu de variété linguistique sur ces médias).
  const HIDE_LANGUE = ['cd','dvd','vinyle','k7 audio','k7 video'].includes(PRODUCT_TYPE);
  const XFACETS = (cfg.dataset.crossfacets || '').split(',').map(s => s.trim()).filter(Boolean)
    .map(s => { const [et, ...lab] = s.split(':'); return { et: et, label: lab.join(':') || et }; });
  if (!ETYPE || !HANDLE || !WORKER) return;

  const grid   = document.getElementById('cat-grid');
  const facets = document.getElementById('cat-facets');
  const pager  = document.getElementById('cat-pagination');
  const countEl= document.getElementById('cat-count');
  const sortEl = document.getElementById('cat-sort');
  const searchEl = document.getElementById('cat-search');

  const state = { page: 1, sort: 'date-descending', format: '', langue: '', etat: '', decade: '', q: '', x: {}, xnom: {}, niv1: '', niv2: '', niv3: '', niv4: '', nivLabels: {} };

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); }
  function money(n){ return n==null ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function normKey(s){ return String(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim(); }

  const CDN = 'https://cdn.shopify.com/s/files/1/0517/5915/3314/files/';
  const CDN2 = 'https://cdn.shopify.com/s/files/1/0550/8585/8967/files/';
  const FORMAT_ICONS = { 'poche': CDN+'icon_livre_format-sm.png?v=1691071327', 'grand format': CDN+'icon_livre_format-lg.png?v=1691071327', 'revue': CDN+'icon_revues.png?v=1691071326', 'bd': CDN+'icon_bd.png?v=1691071327' };
  const LANG_ICONS = { 'francais': CDN+'icon_fr.png?v=1691071291', 'allemand': CDN+'icon_de.png?v=1691071291', 'espagnol': CDN+'icon_es.png?v=1691071291', 'italien': CDN+'icon_it.png?v=1691071291', 'anglais': CDN+'icon_en.png?v=1691071291', 'neerlandais': CDN+'icon_nzl.png?v=1691071291', 'portugais': CDN+'icon_pt.png?v=1691071880', 'breton': CDN+'icon_bzh.png?v=1691071291', 'russe': CDN+'icon_ru.png?v=1696429689', 'polonais': CDN+'icon_pol.png?v=1696429688' };
  const STATE_ICONS = { 'neuf': CDN2+'icon_etat-neuf.png?v=1771074929', 'comme neuf': CDN2+'icon_etat-comme-neuf.png?v=1771074928', 'tres bon etat': CDN2+'icon_etat-tres-bon.png?v=1771074928', 'bon etat': CDN2+'icon_etat-bon.png?v=1771074950', 'correct': CDN2+'icon_etat-correct.png?v=1771074928', 'acceptable': CDN2+'icon_etat-acceptable.png?v=1771074928' };
  function iconSrc(key, val) { const k = normKey(val); return (key==='format'?FORMAT_ICONS:key==='langue'?LANG_ICONS:key==='etat'?STATE_ICONS:{})[k] || ''; }
  function valIcon(key, val) { const s = iconSrc(key, val); return s ? `<img class="facet-icon" src="${s}" alt="" title="${esc(val)}" loading="lazy">` : ''; }
  const CHECKMARK = '<svg class="icon-checkmark" width="11" height="7" viewBox="0 0 11 7" fill="none" aria-hidden="true"><path d="M1.5 3.5L2.83 4.75L4.17 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function qs() {
    const p = new URLSearchParams({ etype: ETYPE, handle: HANDLE, per: PER, page: state.page, sort: state.sort });
    ['format','langue','etat','decade','q','niv1','niv2','niv3','niv4'].forEach(k => { if (state[k]) p.set(k, state[k]); });
    XFACETS.forEach(f => { if (state.x[f.et]) p.set(f.et, state.x[f.et]); });
    return p.toString();
  }

  // ── Produits (chargés EN PREMIER) ───────────────────────────────────────────
  async function loadProducts() {
    grid.setAttribute('aria-busy', 'true');
    let data;
    try { data = await (await fetch(`${WORKER}/cat-products?${qs()}`)).json(); }
    catch (e) { grid.innerHTML = '<li class="cat-empty">Erreur de chargement.</li>'; return; }
    grid.removeAttribute('aria-busy');
    renderGrid(data); renderPager(data);
    if (countEl) countEl.textContent = (data.total || 0).toLocaleString('fr-FR') + ' produit' + (data.total > 1 ? 's' : '');
    updateResetVisibility();
  }

  function card(p) {
    const promo = p.compareAt != null && p.compareAt > p.price;
    const icons = valIcon('format', p.format) + valIcon('langue', p.langue) + valIcon('etat', p.etat);
    const auteur = p.auteur ? `<a class="cat-card__auteur" href="/pages/auteur/${esc(p.auteur.handle)}">${esc(p.auteur.nom)}</a>` : '';
    const collec = p.collection ? `<a class="cat-card__collec" href="/pages/collection-livre/${esc(p.collection.handle)}">${esc(p.collection.nom)}${p.collection.num ? ' n°'+esc(p.collection.num) : ''}</a>` : '';
    // Bouton panier OU badge "Épuisé" si plus de stock (comme la prod)
    let cart = '';
    if (!p.available) {
      cart = '<span class="cat-card__soldout">Épuisé</span>';
    } else if (p.variantId) {
      cart = `<button type="button" class="cat-card__add" data-vid="${p.variantId}" aria-label="Ajouter au panier">${CART_SVG}</button>`;
    }
    return `<li class="cat-card">
      <a class="cat-card__media" href="/products/${esc(p.handle)}">
        ${p.isNew ? '<span class="cat-card__badge">Vient de rentrer</span>' : ''}
        ${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">` : ''}
      </a>
      <div class="cat-card__info">
        <a class="cat-card__title" href="/products/${esc(p.handle)}">${esc(p.title)}</a>
        ${auteur}${collec}
        <div class="cat-card__bottom">
          <div class="cat-card__icons">${icons}</div>
          ${cart}
        </div>
        <p class="cat-card__price"><span class="cat-card__price-sale${promo?' is-promo':''}">${money(p.price)}</span>${promo?`<s class="cat-card__price-was">${money(p.compareAt)}</s>`:''}</p>
      </div></li>`;
  }
  // Même SVG que snippets/icon-lds-quickview.liquid — couleur pilotée par CSS .cat-card__add { color: green }
  const CART_SVG = '<svg class="icon icon-lds icon-quickview" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none"><path fill="currentColor" d="m2.1,31.03c.14.51.13,1.22.05,3.03-.19,4.29-.58,13.19,2.98,17.71,1.45,1.84,3.39,2.77,5.92,2.85,3.71.12,8.5.71,13.55,1.34,6.59.82,13.41,1.67,19.02,1.64,5.93-.03,9.49-1.08,10.56-3.1.36-1.04,4.07-12.4,3.77-25.99,0-.49-.01-.97-.02-1.45-.08-5.68-.14-9.44-5.32-12.14-5.94-3.11-18.18-4.48-39.67-4.45-.18,0-.36-.05-.52-.16L2.98,3.76l2.69,10.67c.06.23.06.48,0,.71-1.86,6.77-3.7,14.53-3.57,15.86m41.16,28.99c-5.58,0-12.28-.83-18.89-1.67-5.02-.63-9.75-1.22-13.38-1.34-3.07-.1-5.54-1.31-7.36-3.62C-.51,48.11-.08,38.52.12,33.9c.04-.87.08-1.86.05-2.16-.18-.53-.36-1.68,1.57-9.6.78-3.22,1.63-6.35,1.91-7.37L.3,1.54c-.12-.48.02-.98.36-1.28C.99-.05,1.44-.09,1.79.17l11.43,7.93h.49c21.32,0,33.59,1.43,39.74,4.66,6.35,3.32,6.43,8.4,6.51,14.27,0,.46.01.94.02,1.42.32,14.72-3.77,26.55-3.95,27.04-.02.05-.04.1-.06.15-1.64,3.3-6.46,4.36-12.7,4.36"/><path fill="currentColor" d="m40.92,29.61c-1.54-.13-3.43-.16-4.97-.23-3.09-.14-6.17-.27-9.25-.46-.69,0-1.88-.06-2.75-.11-.05-.32-.1-.63-.15-.95-.21-1.37-.56-4.5-.76-5.87-.11-.75-.41-.94-1.24-1.06-.62-.09-1.52-.17-2.12-.23-.7-.07-1.92-.21-2.63-.21-1.05,0-1.08,1.23-.73,2.35.39,1.28,1.19,1.02,3.32,1.21.99.09.91.31,1,1.15.48,4.89,1.27,9.75,2.36,14.54.3,1.22.56,1.26,2.8,1.42,1.67.12,5.49.3,7.17.33,1.39.02,2.31.06,3.84.08.69,0,1.38-.03,2.07-.09.91-.1.88-.43,1.21-1.46.77-3.11,1.6-5.69,2.45-8.77.25-.99-.44-1.53-1.59-1.63Zm-2.03,3.92c-.15.54-1.01,3.23-1.28,4.15-.25.85-.66,1.01-1.46,1.04-1.06.04-2.11-.05-3.43-.06-2.05-.03-3.92-.13-5.96-.31-.53-.02-1.19-.09-1.3-.72-.33-1.88-.67-3.76-.99-5.64,1.16.03,2.96.08,4.21.12,1.6.08,3.21.13,4.82.19.94.04,2.64.08,3.58.1,2.41.03,2.08.18,1.82,1.14Zm-12.29,8.65c-.51-.27-1.1-.38-1.68-.29-.31.07-.6.2-.85.4-.25.2-.45.45-.58.74-.2.29-.33.62-.4.97-.06.35-.06.7.02,1.05.09.31.25.59.45.84.21.25.46.45.75.59.29.14.6.23.92.25.32.02.64-.03.95-.14.44-.18.81-.5,1.06-.91.27-.4.44-.86.51-1.34.07-.44,0-.89-.22-1.27-.21-.39-.54-.7-.95-.88Zm8.44.55c-.37-.04-.74.01-1.08.15-.34.14-.65.35-.88.64-.25.29-.44.62-.55.99-.11.36-.15.75-.11,1.13.08.33.24.64.48.89.23.25.52.44.85.55.37.11.76.13,1.13.05.38-.08.72-.26,1.01-.51.43-.4.7-.93.78-1.51.08-.54-.03-1.1-.33-1.56-.15-.22-.34-.4-.56-.54-.22-.14-.47-.23-.73-.27Z"/></svg>';

  function renderGrid(data) {
    const items = data.products || [];
    grid.innerHTML = items.length ? items.map(card).join('') : '<li class="cat-empty">Aucun produit pour cette sélection.</li>';
  }

  function renderPager(data) {
    if (!pager) return;
    const total = data.totalPages || 1;
    if (total <= 1) { pager.innerHTML = ''; return; }
    const cur = data.page || 1, around = 2, set = new Set([1, total]);
    for (let p = cur - around; p <= cur + around; p++) if (p >= 1 && p <= total) set.add(p);
    const pages = [...set].sort((a, b) => a - b); let prev = 0;
    pager.innerHTML = (cur > 1 ? `<button type="button" class="cat-page cat-page--nav" data-page="${cur - 1}">‹</button>` : '') +
      pages.map(p => { const sep = p - prev > 1 ? '<span class="cat-ellipsis">…</span>' : ''; prev = p; return sep + (p === cur
        ? `<span class="cat-page is-current" aria-current="page">${p}</span>`
        : `<button type="button" class="cat-page" data-page="${p}">${p}</button>`); }).join('') +
      (cur < total ? `<button type="button" class="cat-page cat-page--nav" data-page="${cur + 1}">›</button>` : '');
  }

  // ── Facettes (chargées APRÈS les produits) ──────────────────────────────────
  // Seul le premier filtre xfacet (le plus pertinent : Artiste pour CD,
  // Auteur pour Livre, Acteur pour DVD) est ouvert par défaut.
  function xshell(f, idx) {
    const openAttr = idx === 0 ? ' open' : '';
    return `<div class="cat-xfacet cat-facet" data-facet="${esc(f.et)}"><details${openAttr}><summary>${esc(f.label)}</summary>
      <div class="cat-xfacet__search"><input type="search" class="cat-xsearch" placeholder="Rechercher…" autocomplete="off"></div>
      <ul class="cat-xfacet__list cat-facet__list"></ul></details></div>`;
  }
  // CD / Vinyle / K7 audio : ordre spécifique Artiste → Format → État → Label → Catégories → Date
  const IS_CD_LIKE = ['cd','vinyle','k7 audio'].includes(PRODUCT_TYPE);

  function renderShell() {
    const reset = `<div class="cat-facet-reset" hidden><button type="button" id="cat-clear">Tout effacer</button></div>`;
    if (IS_CD_LIKE) {
      // 1er xfacet (Artiste), puis slot Format+État, puis le reste des xfacets, puis le reste des facets standard.
      const xfirst = XFACETS[0] ? xshell(XFACETS[0], 0) : '';
      const xrest  = XFACETS.slice(1).map((f, i) => xshell(f, i + 1)).join('');
      facets.innerHTML = reset + xfirst + `<div id="cat-fe-slot"></div>` + xrest + `<div id="cat-regular"></div>`;
    } else {
      const before = XFACETS.filter(f => f.et !== 'editeur');
      const after  = XFACETS.filter(f => f.et === 'editeur');
      facets.innerHTML = reset + before.map(xshell).join('') + `<div id="cat-regular"></div>` + after.map(xshell).join('');
    }
  }

  // Masque/affiche "Tout effacer" selon l'état des filtres actifs.
  function updateResetVisibility() {
    const wrap = facets && facets.querySelector('.cat-facet-reset');
    if (!wrap) return;
    const hasActive = !!(state.format || state.langue || state.etat || state.decade || state.q
      || state.niv2 || state.niv3 || state.niv4
      || Object.keys(state.x || {}).some(k => state.x[k]));
    wrap.toggleAttribute('hidden', !hasActive);
  }
  async function loadFacets() {
    const reg = document.getElementById('cat-regular'); if (!reg) return;
    // Inclut niv1/2/3 pour que le worker renvoie la bonne tranche d'hiérarchie genre
    const p = new URLSearchParams({ etype: ETYPE, handle: HANDLE });
    ['niv1','niv2','niv3'].forEach(k => { if (state[k]) p.set(k, state[k]); });
    let d; try { d = await (await fetch(`${WORKER}/cat-filters?${p.toString()}`)).json(); } catch (e) { return; }
    // Auto-bind du niv1 dominant (1er chargement uniquement) sans recharger les produits
    if (!state.niv1 && d.genre?.niv1?.id) { state.niv1 = String(d.genre.niv1.id); if (d.genre.niv1.label) state.nivLabels['1'] = d.genre.niv1.label; }
    const group = (title, key, vals, useLabel) => (!vals || !vals.length) ? '' :
      `<details class="cat-facet"><summary>${esc(title)}</summary><ul class="cat-facet__list">` +
      vals.map(v => { const val = v.value, txt = useLabel ? v.label : v.value;
        return `<li><label class="facet-checkbox"><input type="radio" name="f-${key}" value="${esc(val)}"${state[key]===val?' checked':''}>${CHECKMARK}<span class="facet-checkbox__text">${valIcon(key,val)}${esc(txt)} <span class="facet-count">(${v.count})</span></span></label></li>`; }).join('') + `</ul></details>`;
    // Filtre Catégorie hiérarchique (uniquement si niv1 connu)
    const genreHtml = renderGenreFacet(d.genre || {});
    const langueHtml = HIDE_LANGUE ? '' : group('Langue', 'langue', d.langues);
    if (IS_CD_LIKE) {
      const slot = document.getElementById('cat-fe-slot');
      if (slot) slot.innerHTML = group('Format', 'format', d.formats) + group('État', 'etat', d.etats);
      reg.innerHTML = genreHtml + group('Date de sortie', 'decade', d.decades, true) + langueHtml;
    } else {
      reg.innerHTML = genreHtml + group('Date de sortie', 'decade', d.decades, true) + group('Format', 'format', d.formats) + langueHtml + group('État', 'etat', d.etats);
    }
  }

  // Filtre Catégorie hiérarchique — un panneau par niveau, révélation progressive.
  // Niv2 toujours visible (si dispo). Niv3 dans son propre panneau "Sous-catégorie"
  // UNIQUEMENT si un Niv2 est sélectionné ET qu'il a des enfants. Idem Niv4.
  function renderGenreFacet(g) {
    if (!state.niv1 || !g || !g.ng2 || !g.ng2.length) return '';
    const panel = (title, vals, lvl, activeId) => {
      const items = vals.map(v =>
        `<li><label class="facet-checkbox cat-genre-opt" data-lvl="${lvl}" data-id="${esc(v.id)}" data-label="${esc(v.label || v.id)}">` +
        `<input type="radio" name="g-${lvl}" value="${esc(v.id)}"${activeId === String(v.id) ? ' checked' : ''}>${CHECKMARK}` +
        `<span class="facet-checkbox__text">${esc(v.label || v.id)} <span class="facet-count">(${v.count})</span></span></label></li>`
      ).join('');
      return `<details class="cat-facet cat-genre cat-genre--lvl${lvl}" open><summary>${esc(title)}</summary><ul class="cat-facet__list">${items}</ul></details>`;
    };
    let html = panel('Catégorie', g.ng2, 2, state.niv2);
    if (state.niv2 && g.ng3 && g.ng3.length) html += panel('Sous-catégorie', g.ng3, 3, state.niv3);
    if (state.niv3 && g.ng4 && g.ng4.length) html += panel('Précision', g.ng4, 4, state.niv4);
    return html;
  }
  async function loadXValues(et, q) {
    const list = facets.querySelector(`.cat-xfacet[data-facet="${et}"] .cat-xfacet__list`); if (!list) return;
    let d; try { d = await (await fetch(`${WORKER}/cat-facet-values?etype=${encodeURIComponent(ETYPE)}&handle=${encodeURIComponent(HANDLE)}&facet=${encodeURIComponent(et)}&q=${encodeURIComponent(q||'')}&limit=40`)).json(); } catch (e) { return; }
    list.innerHTML = (d.values || []).map(v =>
      `<li><label class="facet-checkbox cat-xopt" data-eid="${esc(v.eid)}" data-nom="${esc(v.nom)}"><input type="checkbox"${state.x[et]===v.eid?' checked':''}>${CHECKMARK}<span class="facet-checkbox__text">${esc(v.nom)} <span class="facet-count">(${v.count})</span></span></label></li>`
    ).join('') || '<li class="cat-xempty">Aucun résultat</li>';
  }

  // ── Events ──────────────────────────────────────────────────────────────
  facets.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name && t.name.indexOf('f-') === 0) { const k = t.name.slice(2); if (state[k] === t.value) { state[k] = ''; t.checked = false; } else state[k] = t.value; state.page = 1; loadProducts(); }
  });
  facets.addEventListener('click', (e) => {
    if (e.target.id === 'cat-clear') { ['format','langue','etat','decade','q','niv2','niv3','niv4'].forEach(k => state[k] = ''); state.x = {}; state.xnom = {}; if (searchEl) searchEl.value = ''; state.page = 1; renderShell(); loadFacets(); XFACETS.forEach(f => loadXValues(f.et, '')); loadProducts(); return; }
    // Genre hiérarchique : sélection niv2/3/4 → drill-down ou toggle off
    const gopt = e.target.closest('.cat-genre-opt');
    if (gopt) {
      const lvl = gopt.dataset.lvl, id = gopt.dataset.id, key = 'niv' + lvl;
      if (state[key] === id) {
        // toggle off : nettoie le niveau courant + niveaux inférieurs
        for (let l = parseInt(lvl, 10); l <= 4; l++) state['niv' + l] = '';
      } else {
        state[key] = id;
        // reset des niveaux inférieurs
        for (let l = parseInt(lvl, 10) + 1; l <= 4; l++) state['niv' + l] = '';
      }
      state.page = 1; loadFacets(); loadProducts(); return;
    }
    const opt = e.target.closest('.cat-xopt');
    if (opt) { const et = opt.closest('.cat-xfacet').dataset.facet; const eid = opt.dataset.eid;
      if (state.x[et] === eid) { state.x[et] = ''; } else { state.x[et] = eid; state.xnom[et] = opt.dataset.nom; }
      state.page = 1; const inp = facets.querySelector(`.cat-xfacet[data-facet="${et}"] .cat-xsearch`); loadXValues(et, inp ? inp.value.trim() : ''); loadProducts(); }
  });
  let xt; facets.addEventListener('input', (e) => { if (!e.target.classList.contains('cat-xsearch')) return; const et = e.target.closest('.cat-xfacet').dataset.facet; clearTimeout(xt); xt = setTimeout(() => loadXValues(et, e.target.value.trim()), 250); });

  // Ajout panier depuis la carte + déclenche la cart-notification Dawn.
  // On calque le pattern Dawn (cf. product-form.js) : FormData + X-Requested-With.
  grid.addEventListener('click', async (e) => {
    const btn = e.target.closest('.cat-card__add'); if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    const variantId = btn.dataset.vid;
    try {
      const notif = document.querySelector('cart-notification');
      const SECTIONS = notif
        ? notif.getSectionsToRender().map(s => s.id)
        : ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      const fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      fd.append('sections', SECTIONS.join(','));
      fd.append('sections_url', window.location.pathname);
      const r = await fetch('/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      });
      const parsed = await r.json();
      btn.classList.remove('is-loading');
      if (parsed.status) {
        // erreur Shopify (rupture, etc.)
        console.error('[cat-entity] cart/add erreur:', parsed.description || parsed.message);
        return;
      }
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Déclenche le popup Dawn : il attend l'objet response brut, pas un wrapper.
      if (notif) notif.renderContents(parsed);
    } catch (err) {
      btn.classList.remove('is-loading');
      console.error('[cat-entity] cart/add exception:', err);
    }
  });

  if (pager) pager.addEventListener('click', (e) => { const b = e.target.closest('[data-page]'); if (!b) return; state.page = parseInt(b.dataset.page, 10); loadProducts(); window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' }); });
  if (sortEl) { sortEl.value = state.sort; sortEl.addEventListener('change', () => { state.sort = sortEl.value; state.page = 1; loadProducts(); }); }
  if (searchEl) { let tmr; searchEl.addEventListener('input', () => { clearTimeout(tmr); tmr = setTimeout(() => { state.q = searchEl.value.trim(); state.page = 1; loadProducts(); }, 300); }); }

  // Skeleton immédiat dans la grille pour éviter la page vide
  if (grid && !grid.innerHTML) {
    var skeletonCount = 12;
    var sk = '';
    for (var i = 0; i < skeletonCount; i++) {
      sk += '<li class="cat-card cat-card--skeleton"><div class="cat-card__media"></div><div class="cat-card__info"><span class="sk sk-l1"></span><span class="sk sk-l2"></span><span class="sk sk-l3"></span></div></li>';
    }
    grid.innerHTML = sk;
  }

  // 1) Produits en priorité — fetch lancée immédiatement, ne dépend de rien.
  // 2) Shell des filtres rendu en synchrone (vide).
  // 3) Les facettes ne se chargent QU'APRÈS rendu des produits → la zone
  //    produits ne reste jamais vide pendant que les facettes calculent.
  var productsLoaded = loadProducts();
  renderShell();
  Promise.resolve(productsLoaded).then(function () {
    loadFacets();
    XFACETS.forEach(function (f) { loadXValues(f.et, ''); });
  });
})();
